import {Grid, Typography} from '@mui/material';
import {t} from 'i18next';
import React, {useState} from 'react';
import AurButton from '../../common/aur-button/AurButton';

interface Props {
  property: {
    key: string;
    value: string;
    displayExpandCollapseButton?: boolean;
    clientPermInfo?: {
      name?: string;
      description?: string;
    };
  };
  showPermDeatils?: (id: string) => void;
}

const AurClientListProperties: React.FC<Props> = ({
  property: {key, value, clientPermInfo},
  showPermDeatils,
}) => {
  const [isExpanded] = useState(false);
  return (
    <Grid className="client-list-properties" container>
      <Grid item xs={2} className="client-list-properties-key">
        <Typography className="typo-text subhead3_size">{key}</Typography>
      </Grid>
      <Grid item xs className="client-list-properties-value">
        {key == t('addEditTeamMember.form.clientPermissionGroupLabel') ? (
          <>
            <Typography className="typo-text subhead4_size heading-color">
              {clientPermInfo?.name}
            </Typography>
            <Typography className={`typo-text body2_size`}>
              {clientPermInfo?.description}
            </Typography>
            <AurButton
              ariaLabel={t(
                'addEditTeamMember.form.clientPermissionGroupDetails'
              )}
              disabled={false}
              onClick={() => {
                showPermDeatils && showPermDeatils(value);
              }}
              type="text"
              size="Small"
              label={t('addEditTeamMember.form.clientPermissionGroupDetails')}
              classNames="remove-padding"
            />
          </>
        ) : (
          <Typography
            className={`typo-text body2_size ${!isExpanded && 'proerties-value-word-wrap'}`}
          >
            {value}
          </Typography>
        )}
        {/* {displayExpandCollapseButton && (
          <div
            style={{
              marginLeft: '-16px',
            }}
          >
            <AurButton
              label={isExpanded ? 'Hide' : 'View All Workspaces'}
              startIcon={isExpanded ? <UpIcon /> : <DownIcon />}
              type="text"
              onClick={() => setIsExpanded((prev) => !prev)}
              size="Small"
            />
          </div>
        )} */}
      </Grid>
    </Grid>
  );
};

export default AurClientListProperties;
